export enum OriginSpend {
	App = 0,
	Rfe = 1
}
